import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Button, Paper, Typography } from '@mui/material'
import Refresh from '@mui/icons-material/Refresh'
import { useGetPortfoliosQuery } from '../../../../api-services/asset-holdings/portfolioSettlementsApi'
import { NumberFormatter } from '../../../../utility/formatters/NumberFormatter'
import MUIDataTable, { type MUIDataTableOptions, type SelectableRows } from 'mui-datatables'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import { StartOutlined } from '@mui/icons-material'

const SettlementsPage: React.FC = () => {
  const history = useHistory()
  // const dispatch = useAppDispatch()

  const goTo = (location: string): void => {
    history.push(location)
  }

  const getPortfoliosApiResult = useGetPortfoliosQuery({})
  const refetchPortfolios = getPortfoliosApiResult.refetch

  const handleRefetch = async (): Promise<void> => {
    await refetchPortfolios()
  }

  const portfolioColumns = [
    { name: 'id', label: 'ID', options: { filter: true, sort: true } },
    { name: 'buyer', label: 'Buyer', options: { filter: true, sort: true } },
    { name: 'transferDate', label: 'Transfer Date', options: { filter: true, sort: true } },
    { name: 'state', label: 'State', options: { filter: true, sort: true } },
    {
      name: 'portfolioSettlementProjects',
      label: '# of Projects',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (<span>{NumberFormatter.roundToString(value.length, 0)}</span>)
        }
      }
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <Button onClick={() => { goTo(`/app/finance-area/settlements/${tableMeta.rowData[0]}/edit`) }} type={'button'} variant={'text'}>
              <StartOutlined />
            </Button>
          )
        }
      }
    }
  ]

  const optionsPortfolios: MUIDataTableOptions = {
    expandableRows: false,
    expandableRowsOnClick: false,
    selectableRowsHideCheckboxes: true,
    selectableRows: 'none' as SelectableRows,
    fixedHeader: true
  }

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ p: 1, flexGrow: 1 }}>
          <Typography variant={'h4'}>Settlements Admin</Typography>
        </Box>
        <Box sx={{ p: 1 }}>
          <Button variant={'outlined'} type="button" onClick={handleRefetch}>
            <Refresh/>
          </Button>
        </Box>
      </Box>

      <Paper>
        <Box sx={{ p: 4, mt: 3 }}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ p: 1, flexGrow: 1 }}>

            </Box>
            <Box sx={{ p: 1 }}>
              <Button variant={'contained'} type='button' disabled={true}>
                Create Settlement Portfolio
              </Button>
            </Box>
          </Box>
          { getPortfoliosApiResult.isLoading && <LoadingComponent />}
          { getPortfoliosApiResult.isError && <ErrorComponent message={JSON.stringify(getPortfoliosApiResult.error)} />}
          { getPortfoliosApiResult.isSuccess && (
            <MUIDataTable
              title = {'Portfolio Settlements'}
              data = { getPortfoliosApiResult.data }
              columns = { portfolioColumns }
              options = { optionsPortfolios }>
            </MUIDataTable>
          )}
        </Box>
      </Paper>
    </>
  )
}

export default SettlementsPage
